export default __webpack_public_path__ + "static/logo_main-2dac5f5cfbe1d19a2c3613acddc352bc.png";